import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="calculator-fed"
        path="/calculator-fed/:id?"
        component={Page} />
];

export default Routes;